/**
 * UserAvatar — Reusable profile photo / initials avatar component.
 *
 * Shows the user's profile photo if available, otherwise falls back to initials.
 * Use this everywhere a user avatar is needed for consistency.
 */
import React from 'react';

interface UserAvatarProps {
  user?: {
    first_name?: string;
    last_name?: string;
    profile_picture_url?: string;
  } | null;
  size?: number;
  className?: string;
}

const UserAvatar: React.FC<UserAvatarProps> = ({ user, size = 36, className = '' }) => {
  const initials = `${user?.first_name?.charAt(0) || ''}${user?.last_name?.charAt(0) || ''}`.toUpperCase() || '?';
  const hasPhoto = !!user?.profile_picture_url;

  return (
    <div
      className={`rounded-full flex items-center justify-center font-bold text-white overflow-hidden shrink-0 ${className}`}
      style={{ width: size, height: size, fontSize: Math.max(size * 0.35, 10), backgroundColor: hasPhoto ? 'transparent' : '#334155' }}
    >
      {hasPhoto ? (
        <img src={user!.profile_picture_url!} alt={initials} className="w-full h-full object-cover" style={{ border: 'solid 3px #e2e8f0', borderRadius: 100 }} />
      ) : (
        initials
      )}
    </div>
  );
};

export default UserAvatar;
